// extracted by mini-css-extract-plugin
module.exports = {"diamonds":"SellYourDiamonds_diamonds__Rt0oQ","diamonds_images":"SellYourDiamonds_diamonds_images__xkseF","button_container":"SellYourDiamonds_button_container__Ls2Qu"};